module.exports = __webpack_public_path__ + "static/media/tip2.2dd7297e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Confirmation/img/tips/tip2.jpg
// module id = 973
// module chunks = 0